import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const TOKEN_KEY = "roots_admin_token";

export const fetchEdition = (slug, lang) =>
  axios.get(`${API}/editions/${slug}`, { params: { lang } }).then((r) => r.data);

export const trackRead = (edition, lang, page) =>
  axios.post(`${API}/reads`, { edition, lang, page }).catch(() => {});

export const shareUrl = (slug, lang, n) => `${API}/share/${slug}/${lang}/${n}`;
export const pdfUrl = (slug, lang) => `${API}/editions/${slug}/pdf?lang=${lang}`;

const sleep = (ms) => new Promise((r) => setTimeout(r, ms));

export const downloadPdf = async (slug, lang, onProgress) => {
  for (let i = 0; i < 150; i++) {
    const s = await axios.post(`${API}/editions/${slug}/pdf/prepare`, null, { params: { lang } }).then((r) => r.data);
    if (s.ready) break;
    if (s.status === "error") throw new Error(s.error || "PDF generation failed");
    onProgress?.(i);
    await sleep(2000);
  }
  const res = await axios.get(pdfUrl(slug, lang), { responseType: "blob", timeout: 180000 });
  if (res.status === 202) throw new Error("PDF is still being prepared — please try again in a moment");
  const href = URL.createObjectURL(res.data);
  const a = document.createElement("a");
  a.href = href;
  a.download = `ROOTS-Edition-${slug}-${lang.toUpperCase()}.pdf`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(href), 10000);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));
const auth = () => ({ headers: { Authorization: `Bearer ${getToken()}` } });

export const adminLogin = (email, password) => axios.post(`${API}/auth/login`, { email, password }).then((r) => r.data);
export const adminMe = () => axios.get(`${API}/auth/me`, auth()).then((r) => r.data);
export const fetchAssets = () => axios.get(`${API}/admin/assets`, auth()).then((r) => r.data);
export const updatePage = (slug, lang, n, body) => axios.put(`${API}/admin/pages/${slug}/${lang}/${n}`, body, auth()).then((r) => r.data);
export const resetPage = (slug, lang, n) => axios.post(`${API}/admin/pages/${slug}/${lang}/${n}/reset`, {}, auth()).then((r) => r.data);

export const fetchEditions = () => axios.get(`${API}/editions`).then((r) => r.data);
export const fetchTranslations = () => axios.get(`${API}/admin/translations`, auth()).then((r) => r.data);
export const startTranslation = (lang) => axios.post(`${API}/admin/translations/${lang}`, null, auth()).then((r) => r.data);
export const approveTranslation = (lang, status = "approved") => axios.post(`${API}/admin/translations/${lang}/approve`, null, { ...auth(), params: { status } }).then((r) => r.data);
export const deleteTranslation = (lang) => axios.delete(`${API}/admin/translations/${lang}`, auth()).then((r) => r.data);

export const formatApiError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return d.msg || String(d);
};
